import styled from 'styled-components'

import { customMedia, THEME, typeScale } from '../../styles'
import Icon from '../Icon'
import NavLink from '../NavLink'

const Styled = styled.div``
Styled.ingredientList = styled.div`
  padding: 0;
  margin: 0 auto;
  max-width: 27rem;
  ${customMedia('420px')`
    max-width: none;
  `}
`
Styled.ingredient = styled.div`
  display: block;
  text-decoration: none;
  cursor: default;
`
Styled.ingredientLink = styled(NavLink)`
  display: block;
  text-decoration: none;
  cursor: default;
`
Styled.ingredientListInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  margin: -0.8rem;
  /* stylelint-disable-next-line */
  & > ${Styled.ingredientLink}, & > ${Styled.ingredient} {
    margin: 0.8rem;
  }
`
Styled.additionalIngredientsList = styled.div`
  padding-top: 4.8rem;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    border-bottom: 0.1rem dashed ${THEME.COLORS.foreground.secondary};
    height: 0.1rem;
    width: 100%;
    top: 2.4rem;
    left: 0;
  }
`
Styled.additionalIngredientsLabel = styled.p`
  text-align: center;
  padding-bottom: 0.8rem;
`
Styled.additionalIngredients = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;
`
Styled.additionalIngredient = styled.div`
  ${typeScale('caption')};
`
Styled.additionalIngredientName = styled.span`
  color: ${THEME.COLORS.foreground.primary};
`
Styled.additionalIngredientQuantity = styled.span`
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.additionalIngredientsHelp = styled(Icon)`
  margin-left: 0.4rem;
  width: 1.6rem;
  height: 1.6rem;
`

export default Styled
